/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPinterest = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 1C5.925 1 1 5.925 1 12c0 4.66 2.9 8.644 6.991 10.247-.096-.87-.183-2.21.039-3.16.2-.858 1.29-5.467 1.29-5.467s-.33-.659-.33-1.633c0-1.53.887-2.672 1.99-2.672.94 0 1.393.705 1.393 1.55 0 .944-.601 2.355-.912 3.662-.259 1.095.55 1.988 1.63 1.988 1.954 0 3.457-2.061 3.457-5.037 0-2.634-1.892-4.475-4.594-4.475-3.13 0-4.967 2.347-4.967 4.773 0 .946.364 1.96.818 2.51a.33.33 0 0 1 .077.316c-.084.348-.27 1.095-.306 1.248-.048.201-.16.244-.368.147-1.374-.64-2.233-2.648-2.233-4.262 0-3.47 2.521-6.656 7.268-6.656 3.816 0 6.782 2.719 6.782 6.353 0 3.791-2.39 6.842-5.708 6.842-1.115 0-2.163-.58-2.522-1.263l-.685 2.615c-.248.955-.919 2.153-1.367 2.883 1.03.32 2.123.491 3.257.491 6.075 0 11-4.925 11-11S18.075 1 12 1"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgPinterest as Pinterest };
